import { Button } from "@/components/ui/button";
import { cn } from "@/utils/classes";
import { PlusIcon } from "@heroicons/react/24/outline";
import { ReactNode } from "react";

/* Prop types */
interface ContextsEmptyStateProps {
  className?: string;
  onClick?: () => void;
  showTitle?: boolean;
  emptyMessage: ReactNode;
}

/*
 * Contexts EmptyState component
 */
export const ContextsEmptyState = ({ className, onClick, showTitle = true, emptyMessage }: ContextsEmptyStateProps) => {
  /* Render */
  return (
    <div className={cn("flex flex-col items-center justify-center gap-4 py-4", className)}>
      {showTitle && <h2 className="text-base-content">Looks like you have no context pack yet</h2>}
      {emptyMessage && <p className="text-base-content/70">{emptyMessage}</p>}
      <video src="/videos/upload-context-animation.webm" className="w-96 pb-2" autoPlay muted loop />
      <Button variant="primary" onClick={onClick}>
        <PlusIcon className="size-4" />
        New context pack
      </Button>
    </div>
  );
};
